import { createAction, props } from '@ngrx/store';

const GET_USERS = '[Users] Get Users';
const GET_USERS_SEARCH = '[Users] Get Users For Search';
const GET_USERS_SORTING = '[Users] Get Users With Sorting';
const SAVE_USERS = '[Users] Save Users';
const SENT_USERS = '[Users] Sent Users';
const SET_USERS = '[Users] Set Users';
const UPDATE_USERS = '[Users] Update Users';
const DELETE_USERS = '[Users] Delete Users';
const SENT_DELETE_USERS = '[Users] Delete Sent Users';
const GET_SID_BASED_USERS = '[Users] Get SID Based Users';
const GET_APPS_BASED_USERS = '[Users] Get Apps Based Users';
const SET_APPS_BASED_USERS = '[Users] Set Apps Based Users';
const SET_SID_BASED_USERS = '[Users] Set SID Based Users';
const GET_USERS_BASED_SEARCH = '[Apps] Get Users Based Search';
const ERROR_MESSAGE = '[Users] Error Message Users';

const getUsers = createAction(GET_USERS, props<{ apiConstants: any; filter: any; orgChange?: boolean }>());

const getUsersForSearch = createAction(
  GET_USERS_SEARCH,
  props<{ apiConstants: any; filter: any; orgChange?: boolean }>()
);

const getUsersWithSorting = createAction(GET_USERS_SORTING, props<{ apiConstants: any; filter: any }>());

const setUsers = createAction(SET_USERS, props<{ usersData: any; totalRecords: any }>());

const setUsersForSearch = createAction(SET_USERS, props<{ usersData: any; totalRecords: any }>());

const sentUsers = createAction(SENT_USERS, props<{ apiConstants: any; saveUsersData: any }>());
const saveUsers = createAction(SAVE_USERS, props<{ saveUsersData: any }>());

const updateUsers = createAction(UPDATE_USERS, props<{ updateUsersData: any }>());

const sentDeleteUsers = createAction(
  SENT_DELETE_USERS,
  props<{ apiConstants: any; usersId: string; userEmail: string }>()
);

const deleteUsers = createAction(DELETE_USERS, props<{ usersId: string }>());

const getSidBasedUsers = createAction(
  GET_SID_BASED_USERS,
  props<{
    apiConstants: any;
    sid: any;
  }>()
);
const getAppForUsers = createAction(
  GET_APPS_BASED_USERS,
  props<{
    apiConstants: any;
    params: any;
  }>()
);
const setSidBasedUsers = createAction(
  SET_SID_BASED_USERS,
  props<{
    sidUserData: any;
  }>()
);
const setAppForUsers = createAction(
  SET_APPS_BASED_USERS,
  props<{
    sidAppData: any;
  }>()
);

const getUsersBasedOnSearch = createAction(GET_USERS_BASED_SEARCH, props<{ apiConstants: any; searchFields: any }>());
const getErrorMessage = createAction(ERROR_MESSAGE, props<{ errorMessage: any }>());
export {
  getUsers,
  saveUsers,
  updateUsers,
  deleteUsers,
  setUsers,
  sentUsers,
  sentDeleteUsers,
  getSidBasedUsers,
  getUsersForSearch,
  setSidBasedUsers,
  setAppForUsers,
  getUsersWithSorting,
  setUsersForSearch,
  getUsersBasedOnSearch,
  getErrorMessage,
  getAppForUsers
};
